import { useQuery } from "@apollo/client";
import { Button, CircularProgress, FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material"
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getAccountSurveyQuery } from "../queries/GetAccounSurveys";

const GogasForms = () => {
    // acc_id=${auth?.account_id}&sales_mob=${auth?.details?.phone}&sales_name=${auth?.username}
    const nav = useNavigate()
    const queryParams = new URLSearchParams(window.location.search);
    const accId = queryParams.get("acc_id") || 0;
    const sales_mob = queryParams.get("sales_mob") || 0;
    const sales_name = queryParams.get("sales_name") || 0;
    const { data, loading } = useQuery(getAccountSurveyQuery, {
        variables: { "_eq": accId },
        context: {
            headers: {
                "Authorization": `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTczMTk0ODc1MywiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.pUzE1aMlcZs2TPEEGxoUFCqsnJVRKvq26soGc5l0SMo`
            }
        }
    })

    const [selectedValue, setSelectedValue] = useState(null);
    console.log(accId, 'params', data);

    const user_details = { shift: "", username: '', station_name: '', dispenser_no: "", dispenser_side: '' };

    if (data?.account_surveys?.length > 0) {
        user_details.username = data?.account_surveys[0]?.account?.username || ''
        user_details.shift = data?.account_surveys[0]?.account?.username[0] < 4 ? data?.account_surveys[0]?.account?.username.split('')[0] : ""
        user_details.dispenser_no = data?.account_surveys[0]?.account?.username[0] < 4 ? data?.account_surveys[0]?.account?.username.split('')[1] : ""
        user_details.station_name = data?.account_surveys[0]?.account?.details?.station_name
        user_details.dispenser_side = data?.account_surveys[0]?.account?.username[0] < 4 ? data?.account_surveys[0]?.account?.username.split('')[4] : ""
    }

    const handleRadioChange = (event) => {
        console.log(event);
        setSelectedValue(event.target.value)
    }

    const onGotoClick = () => {
        console.log(selectedValue)
        const link = data?.account_surveys.filter(x => x.survey_id == selectedValue)[0]?.survey.link
        nav(`/csv/${link}?acc_id=${accId}&sales_mob=${sales_mob}&sales_name=${sales_name}`)
    }

    if (loading) {
        return <div
            style={{
                width: "100%",
                height: "90vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // background: "#FFF7DF",
            }}
        >
            <CircularProgress />
        </div>
    }

    return (
        <div
            style={{
                width: "100%",
                height: "90vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: 'column',
                gap: 12
                // background: "#FFF7DF",
            }}
        >
            <h1>Go Gas forms</h1>
            <div style={{ display: 'flex', flexDirection: "column", gap: 6, alignItems: 'center' }}>
                <label>User name: {user_details.username}</label>
                <label>Shift: {user_details.shift}</label>
                <label>Dispenser no: {user_details.dispenser_no}</label>
                <label>Dispenser side: {user_details.dispenser_side}</label>
                <label>Station name: {user_details.station_name}</label>
            </div>
            <FormControl>
                {/* <FormLabel id="demo-radio-buttons-group-label">Gender</FormLabel> */}
                <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                >
                    {
                        data?.account_surveys.map((item) => (
                            <FormControlLabel
                                sx={{ color: item?.survey_id === 1552 ? 'blue' : item?.survey_id === 1695 ? "#FFD20F" :item?.survey_id === 1805 ? "#FFD20F" : item?.survey_id === 1215 ? "green" : item?.survey_id === 1660 ? "red" : "black" }}
                                onChange={handleRadioChange}
                                value={item?.survey_id}
                                key={item?.survey_id}
                                control={<Radio />}
                                label={item.survey.name} />
                        ))
                    }

                </RadioGroup>
            </FormControl>
            <Button variant="contained" color="secondary" style={{ width: 280, marginTop: 12, borderRadius: 4 }} onClick={onGotoClick}>Go to</Button>
        </div>
    )
}

export default GogasForms;